const binding = { modules: {}, dataActions: {} };

    const registerActionId = (actionPath) => {
        if (binding.dataActions[actionPath] &&
            binding.dataActions[actionPath].default &&
            binding.dataActions[actionPath].default.prototype &&
            binding.dataActions[actionPath].default.prototype.id) {
            binding.dataActions[binding.dataActions[actionPath].default.prototype.id] = binding.dataActions[actionPath];
        } else {
            Object.keys(binding.dataActions[actionPath] || {}).forEach(exportName => {
                if (binding.dataActions[actionPath][exportName] &&
                    binding.dataActions[actionPath][exportName].prototype &&
                    binding.dataActions[actionPath][exportName].prototype.Action) {
                    binding.dataActions[binding.dataActions[actionPath][exportName].prototype.id] = binding.dataActions[actionPath][exportName];
                }
            })
        }
    };

    const registerSanitizedActionPath = (sanitizedActionPath, dataAction) => {
        if (process.env.NODE_ENV === 'development') {
            if (!dataAction.default) {
                throw new Error('Data action path does not have a default export');
            }
            if (!(dataAction.default.prototype.id && binding.dataActions[dataAction.default.prototype.id]) || !binding.dataActions[sanitizedActionPath]) {
                binding.dataActions[sanitizedActionPath] = dataAction;
            }
        } else {
            binding.dataActions[sanitizedActionPath] = dataAction;
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
    };
    

        {   
            const actionPath = 'actions/add-pickup-order-template-to-cart.action';
            binding.dataActions[actionPath] = require('partner/actions/add-pickup-order-template-to-cart.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-attribute-for-selected-variant.action';
            binding.dataActions[actionPath] = require('partner/actions/get-attribute-for-selected-variant.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-availabilities-cartlines.action';
            binding.dataActions[actionPath] = require('partner/actions/get-availabilities-cartlines.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-channel-inventory-configuration.action';
            binding.dataActions[actionPath] = require('partner/actions/get-channel-inventory-configuration.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-delivery-option-context.action';
            binding.dataActions[actionPath] = require('partner/actions/get-delivery-option-context.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-mapped-search-configuration.action';
            binding.dataActions[actionPath] = require('partner/actions/get-mapped-search-configuration.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-price-for-product-search-result.action';
            binding.dataActions[actionPath] = require('partner/actions/get-price-for-product-search-result.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-product-default-variant.action';
            binding.dataActions[actionPath] = require('partner/actions/get-product-default-variant.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-product-refiner-hierarchy.action';
            binding.dataActions[actionPath] = require('partner/actions/get-product-refiner-hierarchy.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-product-search.action';
            binding.dataActions[actionPath] = require('partner/actions/get-product-search.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-product-warranties-in-active-cart.action';
            binding.dataActions[actionPath] = require('partner/actions/get-product-warranties-in-active-cart.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-product-warranties.action';
            binding.dataActions[actionPath] = require('partner/actions/get-product-warranties.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-product-warranty-icon.action';
            binding.dataActions[actionPath] = require('partner/actions/get-product-warranty-icon.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-sales-order-details-by-confirmation-id.action';
            binding.dataActions[actionPath] = require('partner/actions/get-sales-order-details-by-confirmation-id.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-sales-order-with-hydrations.action';
            binding.dataActions[actionPath] = require('partner/actions/get-sales-order-with-hydrations.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-selected-variant.action';
            binding.dataActions[actionPath] = require('partner/actions/get-selected-variant.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-simple-products.action';
            binding.dataActions[actionPath] = require('partner/actions/get-simple-products.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/product-page-summary.action';
            binding.dataActions[actionPath] = require('partner/actions/product-page-summary.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/state-data-actions/product-quantity-state.action';
            binding.dataActions[actionPath] = require('partner/actions/state-data-actions/product-quantity-state.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/state-data-actions/product-warranty-state.action';
            binding.dataActions[actionPath] = require('partner/actions/state-data-actions/product-warranty-state.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'modules/mmx-clearance/actions/search-clearance-lines.action';
            binding.dataActions[actionPath] = require('partner/modules/mmx-clearance/actions/search-clearance-lines.action');
            registerActionId(actionPath);
        }

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.packageDataActions = {};
        window.__bindings__.packageDataActions['__local__'] = {
            ...binding.dataActions
        };